import { Toggle } from '@warp-ds/react/components/toggle';
import { destinations, type PopularDestination } from './destinationFilterData';

type DestinationFilterProps = {
    selectedDestinationLabels: string[];
    onDestinationChange: (destination: PopularDestination) => void;
};

export const DestinationFilter = ({ selectedDestinationLabels, onDestinationChange }: DestinationFilterProps) =>
    destinations.map((destination) => (
        <Toggle
            key={destination.value}
            label={destination.label}
            type="checkbox"
            checked={selectedDestinationLabels.includes(destination.label)}
            onChange={() => onDestinationChange(destination)}
        />
    ));
